import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getGenerationDetails } from "store/slice/linesGeneration";
import Details from "./details";

const LinesGenerationEdit = () => {
    const {generationId} = useParams();
    const dispatch = useDispatch();
    const store = useSelector((store) => store.linesGeneration);
    const shiftConf = store.shiftConf || {};
    
    useEffect(() => {
        if (generationId) {
            dispatch(getGenerationDetails(generationId));
        }
    }, [generationId, dispatch]);
  return (
    <DashboardLayout>
       <Details shiftConf={shiftConf}/>
    </DashboardLayout>
  );
};

export default LinesGenerationEdit;